import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaMoneyBillWave } from "react-icons/fa";

function CashDeposits({ cashDeposits }) {
  return (
    <Col className="cash-deposits">
      <Row className="align-items-center">
        <Col lg={2}>
          <FaMoneyBillWave />
        </Col>
        <Col lg={8}>
          <h5>Efectivo en el mes</h5>
        </Col>
      </Row>
      <Row>
        <Col>
          <h4 className="counter">
            {cashDeposits.toLocaleString("es-MX", {
              style: "currency",
              currency: "MXN",
            })}
          </h4>
        </Col>
      </Row>
    </Col>
  );
}

export default CashDeposits;
